import Select from "./Select";
import React, { useId, useState } from "react";
import { FiCalendar } from "react-icons/fi";
import DateRangeFilter, { DateRange } from "./DateRangeFilter";
import "./DatePresetFilter.css";

export function recentDateRange(days: number, today = new Date()): DateRange {
  const end = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()));
  const start = new Date(end); start.setUTCDate(start.getUTCDate() - days + 1);
  return { startDate: start.toISOString().slice(0, 10), endDate: end.toISOString().slice(0, 10) };
}
export default function DatePresetFilter({ startDate, endDate, onChange, label = "Date range" }: DateRange & { label?: string; onChange: (value: DateRange) => void }) {
  const id = useId();
  const [preset, setPreset] = useState(startDate || endDate ? "custom" : "all");
  return <div className="navo-date-presets">
    <div className="navo-date-presets__select"><FiCalendar aria-hidden="true" />
      <label className="navo-date-presets__label" htmlFor={id}>{label}</label>
      <Select id={id} value={preset} onChange={event => {
        const next = event.target.value; setPreset(next);
        if (next === "all") onChange({ startDate: "", endDate: "" });
        else if (next !== "custom") onChange(recentDateRange(Number(next)));
      }}><option value="all">All time</option><option value="7">Last 7 days</option><option value="30">Last 30 days</option><option value="custom">Custom range</option></Select>
    </div>
    {preset === "custom" && <DateRangeFilter startDate={startDate} endDate={endDate} onChange={value => { onChange(value); if (!value.startDate && !value.endDate) setPreset("all"); }} />}
  </div>;
}
